'use strict'

// TODO: validate user agent

function validate () {}

module.exports = validate
